import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconDocument: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.56886 0H9.96664V4.65417C9.96664 5.99145 10.1059 6.47638 10.3673 6.96527C10.6288 7.45416 11.0125 7.83784 11.5014 8.0993C11.9903 8.36076 12.4752 8.5 13.8125 8.5H18.4666V19.8978C18.4666 21.3242 18.3181 21.8415 18.0392 22.363C17.7603 22.8844 17.3511 23.2937 16.8296 23.5726C16.3081 23.8515 15.7909 24 14.3644 24H4.56886C3.14243 24 2.62517 23.8515 2.10369 23.5726C1.58221 23.2937 1.17294 22.8844 0.894056 22.363C0.615165 21.8415 0.466644 21.3242 0.466644 19.8978V4.1022C0.466644 2.67577 0.615165 2.15851 0.894056 1.63703C1.17295 1.11555 1.58221 0.706286 2.10369 0.427399C2.62517 0.148508 3.14243 0 4.56886 0ZM11.4666 0L18.4666 7H13.7741C12.9718 7 12.6808 6.91645 12.3875 6.75958C12.0941 6.6027 11.8639 6.37249 11.7071 6.07916C11.5502 5.78583 11.4666 5.49487 11.4666 4.6925L11.4666 0Z"
        fill={rest?.$color}
      />
    </svg>
  </IconStyled>
);

IconDocument.defaultProps = iconDefaultProps;
IconDocument.displayName = 'IconDocument';

export default IconDocument;
